import React, { useRef } from 'react'
import { useHistory } from 'react-router'
import Webcam from 'react-webcam'
import { useUser } from '../contexts/user'

export default function Selfie() {
  const { user, setImage } = useUser()
  const history = useHistory()
  const webcam = useRef(null)
  const takePhoto = async () => {
    const image = webcam.current.getScreenshot()
    setImage(image)
    history.push(user.id ? '/home' : '/')
  }
  return (
    <div className="flex flex-col items-center justify-between h-4/5 pt-6">
      <div className="h-80 w-80 bg-white rounded-full flex items-center justify-center">
        <div className="h-76 w-76 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden transitionfix">
          <Webcam
            className="h-full w-full object-cover"
            videoConstraints={{
              width: 640,
              height: 480,
              facingMode: 'user',
            }}
            mirrored={true}
            ref={webcam}
            audio={false}
            screenshotFormat="image/jpeg"
          />
        </div>
      </div>

      <button
        className="bg-dartsee-theme-green w-16 h-16 rounded-full border-4 border-white flex items-center justify-center"
        onClick={takePhoto}
      >
        <img className="w-8 h-8 opacity-40" src="/icon-camera.png" alt="" />
      </button>
    </div>
  )
}
